import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { DatePicker } from 'antd-mobile';
import dayjs from 'dayjs';

const FormInputDate = ({ name, formData, placeholder, changeInputHandle }) => {
    const [text, setText] = useState(formData?.[name] || '');
    const [visible, setVisible] = useState(false);
    // 受控值优先 formData 其次本地
    const value = formData?.[name] || text || '';
    // eslint-disable-next-line no-nested-ternary
    const dateValue = value ? (dayjs(value, 'YYYY/MM/DD').isValid() ? dayjs(value, 'YYYY/MM/DD').toDate() : null) : null;
    // 最小可选日期为1990年1月1日，最大为今天
    const minDateValue = new Date(1900, 0, 1);
    const maxDateValue = new Date();

    return (
        <div className={styles.formInputBox}>
            <div className={styles.formInput} onClick={() => setVisible(true)}>
                {value && value !== '年/月/日' ? <div className={styles.formInputValue1}>{value}</div> : <div className={styles.formInputValue2}>{placeholder || ''}</div>}
            </div>
            <DatePicker
                title={placeholder || ''}
                visible={visible}
                onClose={() => setVisible(false)}
                value={dateValue}
                min={minDateValue}
                max={maxDateValue}
                onConfirm={(val) => {
                    const formatted = dayjs(val).format('YYYY/MM/DD');
                    setText(formatted);
                    changeInputHandle(name, formatted);
                    setVisible(false);
                }}
                precision="day"
                renderLabel={(type, data) => data}
            />
        </div>
    );
};

FormInputDate.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    placeholder: PropTypes.string,
    changeInputHandle: PropTypes.func,
};

export default errorBoundary(FormInputDate);
